// delta2-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{arg1} %{arg2} no total": "%{arg1} %{arg2} en total",
    "%{arg1} %{arg2}h · %{arg3} abastecimentos": "%{arg1} %{arg2}h · %{arg3} cargas de combustible",
    "%{arg1} clientes recuperados no período": "%{arg1} clientes recuperados en el período",
    "%{arg1} pontos": "%{arg1} puntos",
    ", limite por cliente, segmentação por etiqueta, agendamento por dia e horário, e mais de um brinde no mesmo sorteio.": ", límite por cliente, segmentación por etiqueta, programación por día y horario, y más de un premio en el mismo sorteo.",
    "0 4px 12px rgba(46,125,50,0.3)": "0 4px 12px rgba(46,125,50,0.3)",
    "0 8px 32px rgba(0,0,0,0.12)": "0 8px 32px rgba(0,0,0,0.12)",
    "0.5px": "0.5px",
    "1 1 auto": "1 1 auto",
    "16px": "16px",
    "1px dashed rgba(120,105,223,0.35)": "1px dashed rgba(120,105,223,0.35)",
    "1px solid #00897b": "1px solid #00897b",
    "1px solid #2196f3": "1px solid #2196f3",
    "1px solid #4caf50": "1px solid #4caf50",
    "1px solid #7869DF": "1px solid #7869DF",
    "1px solid #f44336": "1px solid #f44336",
    "1px solid #ff9800": "1px solid #ff9800",
    "1px solid rgba(120,105,223,0.10)": "1px solid rgba(120,105,223,0.10)",
    "1px solid rgba(120,105,223,0.12)": "1px solid rgba(120,105,223,0.12)",
    "1px solid rgba(120,105,223,0.2)": "1px solid rgba(120,105,223,0.2)",
    "1px solid rgba(120,105,223,0.22)": "1px solid rgba(120,105,223,0.22)",
    "1px solid rgba(198,40,40,0.15)": "1px solid rgba(198,40,40,0.15)",
    "24px": "24px",
    "2px dashed #ccc": "2px dashed #ccc",
    "2px solid": "2px solid",
    "3 a 32 caracteres, letras e números (ex: ITATIAIA26, RADIO2026, PROMO10)": "3 a 32 caracteres, letras y números (ej: ITATIAIA26, RADIO2026, PROMO10)",
    "34px repeat(24, 1fr)": "34px repeat(24, 1fr)",
    "3px": "3px",
    "64px repeat(12, 1fr)": "64px repeat(12, 1fr)",
    "6px": "6px",
    "A fonte desta seção não tem dados para esta rede.": "La fuente de esta sección no tiene datos para esta red.",
    "A regra \"Pagamento Pix\" é exclusiva e não permite adicionar mais regras.": "La regla \"Pago Pix\" es exclusiva y no permite agregar más reglas.",
    "A vantagem é o que o Clube já sabe fazer e o sorteio nunca soube: regra por": "El beneficio es lo que el Club ya sabe hacer y el sorteo nunca supo: regla por",
    "Adicionando...": "Agregando...",
    "Adicionar Local": "Agregar Lugar",
    "Adicionar Posto": "Agregar Estación",
    "Adicionar Todos": "Agregar Todos",
    "Adicionar Todos os Postos": "Agregar Todas las Estaciones",
    "Adicione os locais onde este produto pode ser resgatado e configure o valor do parceiro.": "Agregue los lugares donde este producto puede canjearse y configure el valor del socio comercial.",
    "Adicione os postos onde este desconto pode ser utilizado.": "Agregue las estaciones donde este descuento puede utilizarse.",
    "Análise iniciada (últimos %{arg1} dias). O resultado aparecerá em alguns minutos.": "Análisis iniciado (últimos %{arg1} días). El resultado aparecerá en algunos minutos.",
    "Bom": "Bueno",
    "Cada nível precisa de um desconto vinculado": "Cada nivel necesita un descuento vinculado",
    "Cancelada em %{arg1}": "Cancelada el %{arg1}",
    "Como funciona \"Completou o cadastro\"?": "¿Cómo funciona \"Completó el registro\"?",
    "Como funciona \"Fez o cadastro\"?": "¿Cómo funciona \"Hizo el registro\"?",
    "Como funciona a regra de Compra?": "¿Cómo funciona la regla de Compra?",
    "Crítico": "Crítico",
    "Defina o prazo de expiração em horas para cada nível": "Defina el plazo de expiración en horas para cada nivel",
    "Desconto aplicado sobre o valor do produto neste local": "Descuento aplicado sobre el valor del producto en este lugar",
    "Entregue uma única vez, quando o cliente completa os dados do perfil.": "Se entrega una única vez, cuando el cliente completa los datos del perfil.",
    "Entregue uma única vez, quando o cliente confirma o cadastro no aplicativo.": "Se entrega una única vez, cuando el cliente confirma el registro en la aplicación.",
    "Erro ao iniciar análise: %{arg1}": "Error al iniciar el análisis: %{arg1}",
    "Excelente": "Excelente",
    "Grupo %{arg1}: %{arg2} (%{arg3}%)": "Grupo %{arg1}: %{arg2} (%{arg3}%)",
    "Imediatamente após a conquista": "Inmediatamente después del logro",
    "Litros mínimos:": "Litros mínimos:",
    "Locais de Resgate para este Produto": "Lugares de Canje para este Producto",
    "Muito bom": "Muy bueno",
    "Nenhum acesso registrado": "Ningún acceso registrado",
    "Nome é obrigatório": "El nombre es obligatorio",
    "Notificação pelo aplicativo": "Notificación por la aplicación",
    "Não publicado": "No publicado",
    "Não é possível adicionar mais grupos porque existe uma regra exclusiva ativa (Clube Certo ou Pagamento Pix). Estas regras não podem ser combinadas com outros grupos usando E TAMBÉM.": "No es posible agregar más grupos porque existe una regla exclusiva activa (Club Correcto o Pago Pix). Estas reglas no pueden combinarse con otros grupos usando Y TAMBIÉN.",
    "Níveis": "Niveles",
    "O desconto deve estar entre 0 e 100": "El descuento debe estar entre 0 y 100",
    "O rastreio de login ainda não tem histórico no sistema.": "El rastreo de inicio de sesión todavía no tiene historial en el sistema.",
    "O sorteio não tem mais regras próprias. Para o cliente ganhar um número da sorte, crie um brinde no Clube de Vantagens com a recompensa": "El sorteo ya no tiene reglas propias. Para que el cliente gane un número de la suerte, cree un premio en el Club de Beneficios con la recompensa",
    "O valor que o parceiro receberá por este produto": "El valor que el socio comercial recibirá por este producto",
    "Postos de Resgate para este Desconto": "Estaciones de Canje para este Descuento",
    "Processando…": "Procesando…",
    "Processar comentários": "Procesar comentarios",
    "Qualquer valor": "Cualquier valor",
    "R$0,00": "R$0,00",
    "Regular": "Regular",
    "Ruim": "Malo",
    "Salvando…": "Guardando…",
    "Selecione a rede": "Seleccione la red",
    "Sem Grupos": "Sin Grupos",
    "Sem abastecer %{arg1}d": "Sin cargar combustible %{arg1}d",
    "Sem dados": "Sin datos",
    "Sem recorrência": "Sin recurrencia",
    "Sem revenda vinculada": "Sin revendedor vinculado",
    "Submissão parada": "Envío detenido",
    "Todos os produtos": "Todos los productos",
    "Valor acumulado:": "Valor acumulado:",
    "Valor automático do catálogo de produtos": "Valor automático del catálogo de productos",
    "Valor mínimo:": "Valor mínimo:",
    "Verificando…": "Verificando…",
    "Verificar agora": "Verificar ahora",
    "abastecimento": "carga de combustible",
    "abastecimentos": "cargas de combustible",
    "achievement": "achievement",
    "all": "all",
    "amount": "amount",
    "apontando para este sorteio, e configure ali quem ganha, quando e quantos números.": "apuntando a este sorteo, y configure allí quién gana, cuándo y cuántos números.",
    "background.paper": "background.paper",
    "chain": "chain",
    "compra": "compra",
    "compras": "compras",
    "continuam funcionando com as regras que já têm — nada precisa ser refeito.": "siguen funcionando con las reglas que ya tienen — no es necesario rehacer nada.",
    "dashed": "dashed",
    "default": "default",
    "disponível apenas por posto — somar entre postos contaria duas vezes quem abastece em mais de um.": "disponible solo por estación — sumar entre estaciones contaría dos veces a quien carga combustible en más de una.",
    "grey.50": "grey.50",
    "linear-gradient(135deg, #5568d3, #6656c7)": "linear-gradient(135deg, #5568d3, #6656c7)",
    "linear-gradient(135deg, #667eea, #7869DF)": "linear-gradient(135deg, #667eea, #7869DF)",
    "negativas": "negativas",
    "neutras": "neutras",
    "notification.sendAt": "notification.sendAt",
    "off": "off",
    "positivas": "positivas",
    "quintil indisponível": "quintil no disponible",
    "repeat(2, 1fr)": "repeat(2, 1fr)",
    "repeat(3, 1fr)": "repeat(3, 1fr)",
    "rgba(102,126,234,0.08)": "rgba(102,126,234,0.08)",
    "rgba(120,105,223,0.04)": "rgba(120,105,223,0.04)",
    "rgba(120,105,223,0.06)": "rgba(120,105,223,0.06)",
    "rgba(120,105,223,0.07)": "rgba(120,105,223,0.07)",
    "rgba(120,105,223,0.25)": "rgba(120,105,223,0.25)",
    "rgba(121,207,98,0.08)": "rgba(121,207,98,0.08)",
    "rgba(148,163,184,0.10)": "rgba(148,163,184,0.10)",
    "rgba(148,163,184,0.18)": "rgba(148,163,184,0.18)",
    "rgba(148,163,184,0.25)": "rgba(148,163,184,0.25)",
    "rgba(148,163,184,0.35)": "rgba(148,163,184,0.35)",
    "rgba(198,40,40,0.05)": "rgba(198,40,40,0.05)",
    "rgba(211, 47, 47, 0.08)": "rgba(211, 47, 47, 0.08)",
    "rgba(239,68,68,0.30)": "rgba(239,68,68,0.30)",
    "rgba(245,158,11,0.30)": "rgba(245,158,11,0.30)",
    "rgba(34,197,94,0.08)": "rgba(34,197,94,0.08)",
    "rgba(34,197,94,0.14)": "rgba(34,197,94,0.14)",
    "rgba(34,197,94,0.30)": "rgba(34,197,94,0.30)",
    "rgba(59,130,246,0.1)": "rgba(59,130,246,0.1)",
    "rgba(59,130,246,0.35)": "rgba(59,130,246,0.35)",
    "sem avaliação": "sin evaluación",
    "success.lighter": "success.lighter",
    "text.primary": "text.primary",
    "value": "value",
    "warning.main": "warning.main",
    "· sentimento dos comentários por IA": "· sentimiento de los comentarios por IA",
};

export default catalogo;
